import SamplePage from "../Pages/SamplePage/SamplePage";
import UsersProfile from "../Pages/Application/Users/UsersProfile/UsersProfile";
import EditProfile from "../Pages/Application/Users/EditProfile/EditProfile";
import UserCards from "../Pages/Application/Users/UserCards/UserCards";
import AddUser from "../Pages/Application/Users/AddUser/AddUser";
import UserEdit from "../Component/Application/Users/EditUser/UserEdit";
import AddBlog from "../Pages/Application/blogs/AddBlog/AddBlog";
import BlogCards from "../Pages/Application/blogs/BlogCards/BlogCards";
import EditBlog from "../Pages/Application/blogs/EditBlog/EditBlog";
import SelfUser from "../Pages/Application/Users/SelfUser/SelfUser";
import SeoAddEdit from "../Pages/Application/blogs/SeoAddEdit/SeoAddEdit";
export const baseRoutes = [
  { path: `/dashboard`, Component: <SamplePage /> },
  { path: `/blogs/add`, Component: <AddBlog /> },
  { path: `/blogs/cards`, Component: <BlogCards /> },
  { path: `/blogs/seo/:id`, Component: <SeoAddEdit /> },
  { path: `/blogs/edit/:id`, Component: <EditBlog /> },
  { path: `/update-profile`, Component: <SelfUser /> },
  {
    path: `/authors/edit/:id`,
    Component: <UserEdit />,
  },
  { path: `/authors/cards`, Component: <UserCards /> },
  { path: `/authors/add`, Component: <AddUser /> },
];

export const superAdminRoutes = [
  { path: `/users/add`, Component: <AddUser /> },
  {
    path: `/users/edit/:id`,
    Component: <UserEdit />,
  },
  { path: `/users/cards`, Component: <UserCards /> },
];
